import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/useAuth.ts';
import { stage } from '../config/stage.ts';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();
  const { pathname } = useLocation();
  const { status } = useAuth();
  // Termly's `.termly-display-preferences` trigger only works where the CMP is
  // loaded — the signed-out home page (see TermlyLoader). There we open the
  // modal inline; everywhere else we link to /legal/cookie-preferences, which
  // loads Termly and auto-opens it. Either way withdrawal is reachable.
  const inlinePreferences = pathname === '/' && status === 'unauthenticated';
  return (
    <footer className="om-footer">
      <div className="om-footer__inner">
        <div className="om-footer__brand">
          <span className="om-footer__brand-mark">◉</span> OculusMind.AI
        </div>
        <nav className="om-footer__links" aria-label="Legal">
          <Link to="/legal/privacy">Privacy</Link>
          <span className="om-footer__sep" aria-hidden="true">·</span>
          <Link to="/legal/terms">Terms</Link>
          <span className="om-footer__sep" aria-hidden="true">·</span>
          <Link to="/legal/ai-consent">AI Consent</Link>
          <span className="om-footer__sep" aria-hidden="true">·</span>
          <Link to="/legal/cookie-policy">Cookies</Link>
          <span className="om-footer__sep" aria-hidden="true">·</span>
          <Link to="/integrations">Integrations</Link>
          <span className="om-footer__sep" aria-hidden="true">·</span>
          <Link to="/legal/about">About</Link>
          <span className="om-footer__sep" aria-hidden="true">·</span>
          <Link to="/legal/contact">Contact</Link>
          <span className="om-footer__sep" aria-hidden="true">·</span>
          <Link to="/legal/licensing">Licensing</Link>
          <span className="om-footer__sep" aria-hidden="true">·</span>
          {inlinePreferences ? (
            <a
              href="#"
              className="termly-display-preferences"
              onClick={(e) => e.preventDefault()}
            >
              Your Privacy Choices
            </a>
          ) : (
            <Link to="/legal/cookie-preferences">Your Privacy Choices</Link>
          )}
        </nav>
        <div className="om-footer__meta">
          <span>© {year} Andrew Paris LLC, d/b/a MediaShare-Link. All rights reserved.</span>
          <span className="om-footer__sep">·</span>
          <span className="om-footer__stage">stage:{stage}</span>
        </div>
      </div>
    </footer>
  );
}
